import AboutPage from '../../src/pages/AboutPage'

/** SSR page: renders AboutPage inside ShopChromeLayout so its content is crawlable. */
export default function AboutPageSsr() {
  return <AboutPage />
}
